/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * GalleryController - beinhaltet die Hauptfunktion der ImageGallery.
 * 
 * Hier wird grundsätzlich auch die Möglichkeit geschaffen Images per
 * Drag & Drop zu verschieben.
 *  
 */
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ImageGallery from "./ImageGallery";

export default function GalleryController() {
    return (
        <DndProvider backend={HTML5Backend}>
            <ImageGallery />
        </DndProvider>
    );
}


